import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import PropTypes from 'prop-types';

import { bem } from 'helpers/class-name';

import OptionRowEditor from './OptionRowEditor';
import './SortableOptionRow.scss';

const { block } = bem('sortable-option-row');

const SortableOptionRow = ({ sortableId, ...rowProps }) => {
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({
    id: sortableId,
  });

  return (
    <div
      ref={setNodeRef}
      className={block({ dragging: isDragging })}
      style={{ transform: CSS.Translate.toString(transform), transition }}>
      <OptionRowEditor {...rowProps} dragHandle={{ setActivatorNodeRef, attributes, listeners }} />
    </div>
  );
};

SortableOptionRow.propTypes = {
  // The field-array key, not the option id: it survives the id adoption after a save.
  sortableId: PropTypes.string.isRequired,
};

export default SortableOptionRow;
